import { render } from "./ExpedientesComponent.vue?vue&type=template&id=f195ddb8"
import script from "./ExpedientesComponent.vue?vue&type=script&lang=js"
export * from "./ExpedientesComponent.vue?vue&type=script&lang=js"

import "./ExpedientesComponent.vue?vue&type=style&index=0&id=f195ddb8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__